var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',{staticClass:"block px-1.5 py-1 text-xs text-gray-400 uppercase tracking-widest font-medium"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }